import ApiDrivenModel from "./ApiDrivenModel";

export default class CatalogActivity extends ApiDrivenModel {
	static ENDPOINT = "Catalog_Activity";
	static SEARCH_PATHS = {
		handle: true,
	}
}
